import {stringifyParams} from '../../../../../modules/apis/ApiFetcher4';

const fetchLangstonSuggestions = async(text = '') => {
  const resource = '/api/v3/content/delivery/suggestions/';

  const queryString = stringifyParams({
    needle: text,
    limit: 5,
  });

  try {
    const response = await fetch(`${resource}${queryString}`, {
      method: 'GET',
      credentials: 'include',
    });
    return await response?.json();
  } catch (error) {
    return error;
  }
};

export {fetchLangstonSuggestions};
